import { BASE_URL } from './Config'; 

export class LogoutService {
    async handleLogout() {
        const token = localStorage.getItem('accessToken');

        try {
            // 1. Optional: Tell backend to blacklist the token (if you have this endpoint)
            if (token) {
                await fetch(`${BASE_URL}/auth/logout`, { // Make sure URL matches your backend!
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                });
            }
        } catch (error) {
            // If the backend doesn't have a logout endpoint, this will fail.
            // We just log it and move on. We DO NOT throw an error here.
            console.warn('Backend logout failed or endpoint missing, proceeding with local logout:', error);
        } finally {
            // check whether the API call succeeded or failed!
            
            // Clear all auth data
            localStorage.removeItem('accessToken');
            localStorage.removeItem('user'); // If you stored user data
            
            // Redirect to login
            // Note: window.location.href is actually GREAT here because it forces 
            // a full page reload, clearing out any sensitive data stuck in React's memory.
            window.location.href = '/login'; 
        }
    }
}